import { render, staticRenderFns } from "./Airline.vue?vue&type=template&id=1cb4d80a&"
import script from "./Airline.vue?vue&type=script&lang=ts&"
export * from "./Airline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports